/* eslint-disable import/prefer-default-export */
import { SET_ACTIVE_TAB } from 'root/src/client/logic/tab/actionIds'
import { tabDescriptionLenses } from 'root/src/client/logic/tab/lenses'

const { setEndpointId } = tabDescriptionLenses

export default {
	[SET_ACTIVE_TAB]: (state, { moduleId, endpointId }) => setEndpointId(moduleId, endpointId, state),
}
